import React from 'react';
import { useSelector } from 'react-redux';
import './Promotions.css';
import { useTranslations } from '../../../../shared/src/hooks/use-translations.hook';
import { Promotion } from './Promotion';
import { OffersDataService } from '../../../services/offers-data.service';

export const Promotions = () => {
    const { promotionsData, pagePurpose } = OffersDataService.getOffersData();
    const { brandName } = useSelector(state => state.app);
    const { t } = useTranslations();
    const isLanding = pagePurpose === 'landing';

    return (<section className="homepage-promotions-container">
        <div className="homepage-promotions-title">
            {`${t('homeNow')}`} {brandName ? brandName : ''}
        </div>

        <div className="homepage-promotions-items">
            {promotionsData.slice(0, 6).map((promo, index) => {
                const { image, title, subtitle, essentialText, badge, fullText, url } = promo;

                return (<Promotion
                    key={index}
                    url={url}
                    image={image}
                    title={title}
                    subtitle={subtitle}
                    essentialText={essentialText}
                    badge={badge}
                    fullText={fullText}
                    isLanding={isLanding}
                />);
            })}
        </div>
    </section>);
};
